import React, { useState } from 'react';
import { formatDeliveryDate } from '../../services/dateUtils';
import * as mealPlanService from '../../services/mealPlanService';

const SkipDelivery = ({
    subscriptionSummary,
    selectedDeliveryDate,
    customerToken,
    onSkipConfirmed,
    customerName
}) => {
    const [showSkipModal, setShowSkipModal] = useState(false);
    const [nextDeliveryDate, setNextDeliveryDate] = useState('');
    const [isSkipping, setIsSkipping] = useState(false);
    const [skipError, setSkipError] = useState('');

    // Calculate allowed dates (selectedDeliveryDate + 7, 14, 21, 28 days)
    const getAllowedDates = () => {
        const baseDate = new Date(selectedDeliveryDate);
        const allowedDates = [];

        for (let i = 1; i <= 4; i++) {
            const date = new Date(baseDate);
            date.setDate(date.getDate() + (i * 7));
            allowedDates.push(date.toISOString().split('T')[0]);
        }

        return allowedDates;
    };

    const handleSkipClick = () => {
        setShowSkipModal(true);
    };

    const handleConfirmSkip = async () => {
        if (!nextDeliveryDate) {
            setSkipError('Please select a new delivery date');
            return;
        }

        setIsSkipping(true);
        setSkipError('');

        try {
            console.log('Calling skipDelivery API with:', { customerToken, selectedDeliveryDate, nextDeliveryDate });
            const response = await mealPlanService.skipDelivery(
                customerToken,
                selectedDeliveryDate,
                nextDeliveryDate,
                subscriptionSummary,
                customerName
            );
            console.log('Skip delivery API response:', response.data);

            if (response.data.success) {
                console.log('Skip delivery successful, calling onSkipConfirmed');
                // Reset states
                setShowSkipModal(false);
                setNextDeliveryDate('');

                // Notify parent that skip was confirmed
                if (onSkipConfirmed) {
                    onSkipConfirmed(nextDeliveryDate);
                }
            } else {
                console.log('Skip delivery API returned success: false');
            }
        } catch (error) {
            console.error('Error skipping delivery:', error);
            setSkipError(error.response?.data?.error || 'Failed to skip delivery');
        } finally {
            setIsSkipping(false);
            setShowSkipModal(false);
        }
    };

    const handleCancelSkip = () => {
        setShowSkipModal(false);
    };

    return (
        <>
            {/* Skip button */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0px'
            }}>
                <div
                    onClick={handleSkipClick}
                    style={{
                        color: 'rgb(136, 130, 130)',
                        cursor: 'pointer',
                        fontSize: '10px',
                        textDecoration: 'underline'
                    }}
                >
                    Skip {formatDeliveryDate(selectedDeliveryDate)} Delivery
                </div>
            </div>

            {/* Skip Confirmation Modal */}
            {showSkipModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: '#fff',
                        borderRadius: '8px',
                        padding: '24px',
                        maxWidth: '600px',
                        width: '90%',
                        maxHeight: '80vh',
                        overflowY: 'auto'
                    }}>
                        <h3 style={{ marginTop: 0, color: '#333' }}>
                            Skip Delivery on {formatDeliveryDate(selectedDeliveryDate)}?
                        </h3>

                        <p style={{ color: '#666', marginBottom: '20px' }}>
                            This will remove all meals for this delivery date. All customization will be lost.
                        </p>

                        {skipError && (
                            <div style={{
                                padding: '10px',
                                backgroundColor: '#f8d7da',
                                color: '#721c24',
                                borderRadius: '4px',
                                marginBottom: '20px'
                            }}>
                                {skipError}
                            </div>
                        )}

                        <div style={{ marginBottom: '20px' }}>
                            <label style={{
                                display: 'block',
                                marginBottom: '8px',
                                color: '#333',
                                fontWeight: 'bold'
                            }}>
                                Choose new delivery date:
                            </label>
                            <select
                                value={nextDeliveryDate}
                                onChange={(e) => setNextDeliveryDate(e.target.value)}
                                style={{
                                    width: '100%',
                                    padding: '8px',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    fontSize: '16px',
                                    backgroundColor: '#fff',
                                    cursor: 'pointer'
                                }}
                            >
                                <option value="">Select a date</option>
                                {getAllowedDates().map(date => (
                                    <option key={date} value={date}>
                                        {formatDeliveryDate(date)}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div style={{
                            display: 'flex',
                            gap: '10px',
                            justifyContent: 'flex-end'
                        }}>
                            <button
                                onClick={handleCancelSkip}
                                disabled={isSkipping}
                                style={{
                                    padding: '10px 20px',
                                    border: '1px solid #6c757d',
                                    borderRadius: '4px',
                                    backgroundColor: '#fff',
                                    color: '#6c757d',
                                    cursor: isSkipping ? 'not-allowed' : 'pointer',
                                    fontSize: '14px',
                                    opacity: isSkipping ? 0.6 : 1
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleConfirmSkip}
                                disabled={isSkipping}
                                style={{
                                    padding: '10px 20px',
                                    border: 'none',
                                    borderRadius: '4px',
                                    backgroundColor: isSkipping ? '#6c757d' : '#dc3545',
                                    color: '#fff',
                                    cursor: isSkipping ? 'not-allowed' : 'pointer',
                                    fontSize: '14px'
                                }}
                            >
                                {isSkipping ? 'Skipping...' : 'Confirm Skip'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default SkipDelivery;